import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app-services/config/config.app';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import { Enums } from '../../enums/enums';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { ServiceAdvertisements } from './advertisement.service';
import { MockServiceAdvertisements } from './advertisement.service.mock';

export function FactoryServiceAdvertisement(http: HttpClient, endpoints: AbstractEndpoints, appMonitoring: AppMonitoring, appConfig: AppConfig) {
    appMonitoring.logEvent('FactoryServiceAdvertisement', 'Advertisement Service Factory loaded');
    switch (appConfig.environment) {
        case Enums.Environments.MockData:
        case Enums.Environments.MockDataWithAuth:
            return new  MockServiceAdvertisements(endpoints, http);
        default:
            return new ServiceAdvertisements(endpoints, http, appConfig)
    }
}
